<template>
  <el-dialog
    :visible.sync="showDialog"
    :show-close="false"
    custom-class="dialog-clear-style"
    width="375px"
    append-to-body
    @close="showDialog = false"
  >
    <div class="dialog-wrap">
      <div class="list-title">
        <span>{{$t('upgrade_page_views_master_index_209')}}</span>
        <fps-icon class="pointer" type="close" size="24" color="#7a7a7a" @click.native="showDialog = false" />
      </div>
      <div v-if="loading" class="loading-wrap">
        <i class="el-icon-loading"></i>
      </div>
      <div v-else-if="list.length" v-infinite-scroll="getMoreList" class="list-wrap">
        <div
          v-for="(f, i) in list"
          :key="'following-' + i"
          class="one-wrap"
          :class="[!btnHover && 'can-hover', showNewUser && f.reddot === 'Display' && 'new-info']"
          @click="jumpDetail(f.uuid)"
        >
        <div class="left-wrap">
          <fps-avatar
            class="user-avatar"
            :src="f.avatarUrl"
          />
          <span class="user-name">{{ f.nickname }}</span>
          <div
            class="userlevel-tag"
            v-if="f.userLevel"
            :class="`level-${f.userLevel}`"
          ></div>
        </div>
          <button
            class="reace-btn"
            :class="f.followStatus === 'Unfollow' ? 'can-follow' : ''"
            @mouseenter="btnHover = true"
            @mouseleave="btnHover = false"
            @click.stop="followItem(f, i)"
          >
            <i v-if="f.loading" class="el-icon-loading"></i>
            <span v-else>{{ f.followStatus === 'Unfollow' ? $t('upgrade_page_views_master_components_some_handle_220') : $t('upgrade_page_views_user_feed_feed_detail_1426') }}</span>
          </button>
        </div>
      </div>
      <div v-else class="no-data-wrap">
        <div class="img-wrap"></div>
        <span>{{$t('upgrade_page_views_player_detail_dialog_follower_1484')}}</span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex'
import { clearRedCircle, getFollowList, followUser } from '@/api'
export default {
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: Boolean,
  },
  data() {
    return {
      showDialog: false,
      loading: false,
      list: [],
      total: 0,
      loadingMore: false,
      btnHover: false,
      showNewUser: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {
    show(show) {
      this.showDialog = show
      this.getDefaultList()
    },
    showDialog(show) {
      this.$emit('change', show)
    },
  },
  created() {
    this.showDialog = this.show
    this.getDefaultList()
  },
  methods: {
    async followItem(f, i) {
      if (f.loading) return
      f.loading = true
      this.list.splice(i, 1, f)
      const followOptType = f.followStatus === 'Unfollow' ? 'Follow' : 'Unfollow'
      if (followOptType === 'Unfollow') {
        try {
          await this.$confirm({
            content: i18n.t('upgrade_page_views_feed_list_index_1419', [ f.nickname ]),
            confirmButtonText: i18n.t('upgrade_page_views_user_feed_feed_detail_1426'),
            cancelButtonText: i18n.t('upgrade_page_layout_header_45'),
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true
          })
        } catch (e) {
          f.loading = false
          this.list.splice(i, 1, f)
          return
        }
      }
      followUser({
        followOptType,
        uuid: f.uuid,
      }).then(() => {
        f.followStatus = followOptType
        f.loading = false
        if (followOptType === 'Unfollow') {
          this.$store.dispatch('app/setSomeUserInfo', {
            following: this.userInfo.following - 1
          })
          this.list.splice(i, 1, f)
        } else {
          this.list.splice(i, 1, f)
          this.$store.dispatch('app/setSomeUserInfo', {
            following: this.userInfo.following + 1
          })
        }
        this.$message.success(i18n.t('upgrade_page_views_user_set_black_1055'))
      }).catch(() => {
        f.loading = false
        this.list.splice(i, 1, f)
        this.$message.error(i18n.t('components_userrelation_index_249'))
      })
    },
    jumpDetail(uuid) {
      this.$router.push({
        path: '/player-detail/' + uuid
      })
    },
    getDefaultList() {
      if (this.show && !this.loading) {
        this.loading = true
        this.list = []
        this.params = {
          pageSize: 28,
          pageIndex: 0,
        } 
        this.getList().then(({ totalRemain }) => {
          clearRedCircle({
            field: 'followers'
          }).then(() => {
            this.$store.dispatch('app/setRedCircle', { followers: false })
          })
          this.total = totalRemain
          this.loading = false
          this.showNewUser = true
          this.$nextTick(() => {
            setTimeout(() => {
              this.showNewUser = false
            }, 3000)
          })
        })
      }
    },
    getList() {
      return getFollowList({
        ...this.params,
        followQueryType: 'Follower',
        uuid: this.userInfo.uuid,
      }).then(({ data }) => {
        const { pageContent } = data
        this.list = this.list.concat(pageContent)
        return data
      })
    },
    getMoreList() {
      if (this.loadingMore || this.total <= this.list.length) return
      this.loadingMore = true
      this.params.pageIndex++
      this.getList().then(() => {
        this.loadingMore = false
      }).catch(() => {
        this.loadingMore = false
      })
    },
  }
}
</script>
<style lang="scss" scoped>
  .dialog-wrap {
    width: 375px;
    margin: 0 auto;
    border-radius: 15px !important;
    background: #fff;
    .list-title {
      width: 100%;
      height: 60px;
      border-bottom: $color-button;
      @include flex(space-between);
      padding: 0 18px;
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      color: $color-gray-1;
    }
    .list-title-2 {
      padding: 16px 18px;
      font-size: 14px;
      line-height: 20px;
      text-align: left;
      color: $color-gray-2;
    }
    .loading-wrap {
      height: 420px;
      @include flex;
      font-size: 28px;
    }
    .list-wrap {
      padding: 16px 20px;
      max-height: 440px;
      overflow-y: auto;
      @include hideScrollBar(0, 0, 0);
      text-align: center;
      font-size: 24px;
      .one-wrap {
        height: 90px;
        @include flex(space-between);
        padding: 0 8px;
        border-radius: 8px;
        cursor: pointer;
        &.can-hover:hover {
          background: $color-split;
        }
        &.new-info {
          background: #FFFADF;
        }
        .user-avatar {
          width: 58px;
          height: 58px;
        }
        .user-name {
          flex-grow: 0;
          margin: 0 2px 0 20px;
          @include ellipsis;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
          text-align: left;
          color: $color-gray-1;
        }
        .reace-btn {
          width: 80px;
          height: 32px;
          border-radius: 16px;
          border: 1px solid $color-split;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 13px;
          line-height: 18px;
          letter-spacing: -0.000319808px;
          color: $color-gray-2;
          &:hover {
            background: rgba(232, 234, 238, 0.3);
          }
        }
        .can-follow {
          border-color: #007AFF;
          color: $color-link;
          &:hover {
            background: rgba(0, 122, 255, 0.1);
          }
        }
      }
    }
    .no-data-wrap {
      @include flex(center, center, column);
      height: 478px;
      .img-wrap {
        width: 108px;
        height: 90px;
        background: url('~@/assets/image/background/empty-search.png') no-repeat center center / 100%;
        margin-bottom: 12px;
      }
      span {
        font-size: 14px;
        line-height: 21px;
        text-align: center;

        color: $color-gray-3;
      }
    }
  }
  .left-wrap {
    display: flex;
    align-items: center;
  }
</style>
